import React, {Component} from 'react';
import axios from 'axios/index';
import {ListButton} from 'admin-on-rest';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {RESOURCES as scheduleResources} from '../fuseReportsResourceMap';
import {getPostHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ScheduleReportForm from '../components/ScheduleReportForm';
import Avatar from 'material-ui/Avatar';
import {Card, CardActions, CardText} from 'material-ui/Card';
import Icon from 'material-ui/svg-icons/action/update';
import {viewStyles} from '../shared/styles-view';

export const fuseScheduleReportIcon = Icon;

/**
 * Page with Scheduled Reports table and form to schedule a Report
 *
 */
export class ScheduleReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
            selectedReportType: null,
            submitting: false,
            success: false
        };
    }

    handleFormSubmit = (data) => {
        this.setState({
            submitting: true
        }, () => {

            const tokenStatus = checkTokenStatus(null);
            if (tokenStatus.expired) {
                return;
            }

            const resource = scheduleResources.ScheduledReports.CREATE(data);
            axios({
                method: resource.method,
                url: resource.uri,
                data: data,
                headers: getPostHeaders()
            }).then((result) => {
                if (result && result.data && result.data.payload) {
                    this.processSubmission(result);
                } else {
                    this.processSubmission(null);
                }
            }).catch((error) => {
                if (error.response) {
                    // Server response outside 2xx
                    console.log(error.response.data);
                    error = error.response.data;
                } else if (error.request) {
                    // No response
                    console.log(error.request);
                    error = error.request;
                } else {
                    console.log('Schedule Report Error', error.message);
                }
                this.processSubmission(null);
            });
        });
    };

    processSubmission = (data) => {
        let success = !!(data);
        this.setState({
            submitting: false,
            success: success
        });
    };

    render() {
        const {
            submitting,
            success
        } = this.state;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Schedule A Report</span>;

        return (
            <div className="lists-container">
                <Card>
                    <CardActions style={viewStyles.actions}>
                        <ListButton basePath="/ScheduledReports"/>
                    </CardActions>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <span className="list-description hide-print">
                            <p>Schedule a Report by completing the options below.</p>
                        </span>
                        <ScheduleReportForm
                            submitting={submitting}
                            success={success}
                            onFormComplete={(e) => this.handleFormSubmit(e)}
                        />
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/views/ScheduleReport.js